import { render, staticRenderFns } from "./ViewHeader.vue?vue&type=template&id=95af0c12&"
import script from "./ViewHeader.vue?vue&type=script&lang=js&"
export * from "./ViewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports